import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';

import { MAX_IMAGE_KB } from '../../utils/constants';
import texts from '../../texts.json';
import SectionCard from '../../components/SectionCard';
import ImagePicker from '../../components/ImagePicker';

const SUBTITLE = format(texts.sections.image.subtitle, { maxKb: MAX_IMAGE_KB });

const ImageSection = ({
  image, onChange, onError, note,
}) => (
  <SectionCard title={texts.sections.image.title} subtitle={SUBTITLE}>
    <ImagePicker image={image} onChange={onChange} onError={onError} note={note} />
  </SectionCard>
);

ImageSection.propTypes = {
  image: ImagePicker.propTypes.image,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func,
  note: PropTypes.string,
};

ImageSection.defaultProps = { image: null, onError: null, note: null };

export default ImageSection;
